<template>
  <a-tree-select
    placeholder="请选择菜单"
    v-model:value="model.pid"
    style="width: 100%"
    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
    :tree-data="treeData"
    :replaceFields="{
      children: 'children',
      title: 'name',
      key: 'id',
      value: 'id',
    }"
  >
  </a-tree-select>
</template>
<script>
import { ref } from "vue";
import menuApi from "@axios/sys/menu";
import menu from "@axios/sysmenu";
export default {
  componentname: "selectMenuTreeSingleClone",
  props: {
    title: {
      type: String,
      default: "请选择部门",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    model: {
      type: Object,
      default: function () {
        return {
          pid: null,
        };
      },
    },
  },
  setup(props, context) {
    let fetching = ref(false);
    let treeData = ref([]);
    const menuListTree = (value) => {
      let params = {};
      fetching.value = true;
      menu
        .menuList(params)
        .then((res) => {
          treeData.value = res;
          fetching.value = false;
        })
        .catch(() => {
          fetching.value = false;
        });
    };

    const change = (value) => {
      if (value) {
        data.value.forEach((ele) => {
          if (ele.id == value) {
            context.emit("setValue", {
              val: value,
            });
          }
        });
      } else {
        context.emit("setValue", {
          val: null,
        });
      }
    };

    menuListTree();

    return {
      change,
      menuListTree,
      fetching,
      treeData,
      model: props.model,
    };
  },
  watch: {
    value(value) {
      console.log(value);
    },
  },
};
</script>
